<template>
    <v-card class="eventday">
        <v-card-text>
            <h3>{{ day | filterDate }}</h3>
            <v-col v-if="!record || !record.events || !record.events.length">
                <v-card class="pa-2 " flat>
                    {{ reports_statusevents.reportConfig.noeventstext || "No events reported" }}
                </v-card>
            </v-col>
            <v-col v-else v-for="item in record.events" :key="item.key">
                <v-row>
                    <v-card class="pa-2 joblabel" flat>
                        <span v-if="getCheckField(item.jobid, 'showlink')">
                            <router-link :to="{ name: 'check status report', params: { uuid: getCheckField(item.jobid, 'uuid'), cid: item.jobid }}">
                                {{  getCheckField(item.jobid, 'label') }}
                            </router-link>
                        </span>
                        <span v-else>{{ getCheckField(item.jobid, 'label') }} </span>
                    </v-card>
                    <v-spacer></v-spacer>
                    <v-card class="pa-2" flat>{{item.start | filterTime}}</v-card>
                </v-row>
                <v-row>
                    <v-card class="pa-2" flat>
                        {{item.type | filterFirstLetter }} {{item | filterDistance}} <span v-if="item.message">:</span> {{item.message}}
                    </v-card>
                </v-row>
                <!-- <template v-if="item.data && showdiag === item.key"> -->
                <div v-for="entry in item.data"  :key="entry.key">
                    <v-row  v-if="entry.type==='note'" class='eventnote'>
                        <v-col class='notetext' v-if="entry.data && entry.data.message" v-html="entry.data.message">
                        </v-col>
                        <v-col class='nottext' v-else-if="entry.data">
                            <code>{{entry.data}}</code>
                        </v-col>
                        <v-col class="noteactions">
                            <div v-if="reports_statusevents.reportConfig.showConfig" >{{entry.visibility | filterFirstLetter}}</div>
                        <!-- <v-btn v-if="mergedConfig.showConfig" outlined small @click="toggleEdit(entry)">Edit Note</v-btn> -->
                        </v-col>
                    </v-row>

                    <div v-else-if="showdiag === entry.key && entry.data" class="diagnosticscontainer">
                        <EventsDiagnosticsView :entry="entry" />
                        <v-btn @click="showdiag=false" outlined small class="showdiagbutton">{{ sizing.closediag }}</v-btn>
                    </div>
                    <div v-else-if="item.data">
                        <v-btn @click="showdiag=entry.key" outlined small>Show diagnostic information</v-btn>
                    </div>
                </div>
                    <!-- <v-row >This information is not publicly visible.</v-row>
                    <v-row>
                        <code>{{item.data}}</code>
                    </v-row>

                    <v-btn @click="showdiag=false" outlined small >Close diagnostic information</v-btn>
                    -->
                <!-- </template>
                <template v-else-if="item.data ">
                    <v-row>
                        <v-btn @click="showdiag=item.key" outlined small>Show diagnostic information</v-btn>
                    </v-row>
                </template>
                -->
            </v-col>

            </v-card-text>
    </v-card>
</template>

<script>
import { mapState } from 'vuex';
import { format as date_format, parse as date_parse, distanceInWordsStrict as date_distance } from "date-fns";
import _find from "lodash/find";

import { formatCapitalizeFirst } from "../lib/filter";
import EventsDiagnosticsView from "./Events_Diagnostics_View";

export default {
    name: "Reports_Status_Events_Day",
    data () {
        return {
            checkcache: {},
            showdiag: false
        }
    },
    props: {
        record: { type: Object },
        day: { type: String }
    },
    components: { EventsDiagnosticsView },
    computed: {
        ...mapState(['checks', 'now', 'reports_statusevents']),
        sizing: function () {
            let breakpoint = this.$vuetify.breakpoint;
            let screenshotsize = breakpoint.width * 0.64;
            return {
                breakpoint: breakpoint,
                screenshotsize: screenshotsize,
                opendiag: (breakpoint.name === "sm" || breakpoint.name === "xs") ? "Open" : "Show diagnostic info",
                closediag: (breakpoint.name === "sm" || breakpoint.name === "xs") ? "Close" : "Close"
            }
        }
    },
    methods: {
        getCheckField: function ( jobid, field ) {
            // console.log('job in filterCheckTitle', this.reports_statusevents.reportChecks );
            let job;
            field = field || 'label';
            if(this.checkcache[jobid]){
                return this.checkcache[jobid][field]
            } else {
                job = _find(this.reports_statusevents.reportChecks, function(record){ return record && record._id === jobid });
                if(job){
                    this.checkcache[jobid] = {
                        label: (job.report && job.report.label) || job.label || jobid,
                        // showlink: this.reports_statusevents.reportConfig.showlinks && job.public,
                        showlink: this.reports_statusevents.reportConfig.showlinks && (this.reports_statusevents.reportConfig.showConfig || job.public),
                        uuid: job.uuid,
                        _id: jobid
                    };
                } else {
                    this.checkcache[jobid] = {
                        label: jobid,
                        showlink: false
                    };
                }
                return this.checkcache[jobid][field];
            }
        }
    },
    filters: {
        filterDate: function (val) {
            if(val){
                let d =  date_format(date_parse(val), "MMM D, YYYY");
                return (d && d !== "NaN" && d !== "Invalid Date") ? d : "";
            } else {
                return "";
            }
        },
        filterTime: function (val) {
            if(val){
                let d =  date_format(date_parse(val), "HH:mm:ss");
                return (d && d !== "NaN" && d !== "Invalid Date") ? d : "";
            } else {
                return "";
            }
        },
        filterDistance: function (val) {
            if(val && val.start && val.end){
                let d =  date_distance(val.start, val.end);
                if(d && d !== "almost NaN years" && d !== "Invalid Date" && d.indexOf('NaN') < 0){
                    return "for " + d;
                }
            }
            return "";
        },
        filterFirstLetter: function (val) {
            return formatCapitalizeFirst(val);
        }
    }
}
</script>

<style scoped>
    .joblabel {
        font-weight: bold;
        font-size: 1.1em;
        color: #333;
    }
    .eventday h3 {
        padding-bottom: 12px;
        border-bottom: 1px solid #ccc;
    }
    .eventday {
        margin-bottom: 12px;
    }
    .diagnosticscontainer {
        padding: 1rem;
        margin-top: 0.8rem;
        border-top: 1px solid #AAA;
        border-bottom: 1px solid #AAA;
    }
</style>